import { useState, useEffect } from "react";
import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import PhoneIcon from "@mui/icons-material/Phone";
import { Link } from "react-router-dom";

export default function NavBottom() {
  const [value, setValue] = useState("/");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    // Set the initial value based on the current URL pathname
    setValue(window.location.pathname);
  }, []);

  return (
    <BottomNavigation
      sx={{
        width: "auto",
        position: { xs: "fixed", md: "static", sm: "fixed" },
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
      }}
      value={value}
      onChange={handleChange}
    >
      <BottomNavigationAction
        label="Home"
        value="/"
        icon={<HomeIcon />}
        component={Link}
        to="/"
      />

      <BottomNavigationAction
        label="Projects"
        value="/projects"
        icon={<RocketLaunchIcon />}
        component={Link}
        to="/projects"
      />

      <BottomNavigationAction
        label="Blog"
        value="/posts"
        icon={<KeyboardIcon />}
        component={Link}
        to="/posts"
      />

      <BottomNavigationAction
        label="Socials"
        value="/socials"
        icon={<PhoneIcon />}
        component={Link}
        to="/socials"
      />
    </BottomNavigation>
  );
}
